import styled from 'styled-components';

import { colors } from '../../../core';
import Button from '../../ui/Button';
import Text from '../../ui/Text';
import { ButtonWrapperProps } from './DocumentUpload.types';

export const StyledInputFileDoc = styled.input`
  display: none;
`;

export const StyledContainer = styled.div`
  margin-top: 30px;
  width: 100%;
`;

export const StyledToolTipContainer = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 30px;
  width: 100%;
`;

export const StyledContainerWithScroll = styled.div`
  max-height: 350px;
  overflow-y: auto;
`;

export const StyledReportWrapper = styled.div`
  margin-top: 30px;

  .react-pdf__Document {
    height: 900px;
    overflow-y: auto;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  pointer-events: none;
`;

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  display: flex;
  gap: 12px;
  margin-top:10px;
  justify-content: ${({ justifyContent }) => justifyContent};
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
`;

export const TableCell = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

export const TableTitle = styled.div`
  font-weight: 700;
`;

export const BottomLine = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.tableBorderColor || colors.cloud};
`;

export const StyledDeleteButton = styled(Button)`
  border: 1px solid ${colors.error};
  color: ${colors.error};
  transition: background-color 0.4s ease, color 0.4s ease;
  background-color: 'transparent';

    &:hover,
    &:focus {
      border-color: rgb(184, 47, 20);
      color: rgb(184, 47, 20);

    }

    &:disabled {
      border-color: ${colors.cloud};
      color: ${colors.cloud};
    }
`;

export const StyledInvalidMessageText = styled(Text)`
  margin-top: 5px;
`
